module.exports = __webpack_public_path__ + "static/media/proj1_img6.f64b1eca.jpg";